var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#B3C1D2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.3835 0 0 5.3835 0 12C0 18.6165 5.3835 24 12 24C18.6165 24 24 18.6165 24 12C24 5.3835 18.6165 0 12 0ZM12 19.5C11.1713 19.5 10.5 18.8288 10.5 18C10.5 17.1712 11.1713 16.5 12 16.5C12.8287 16.5 13.5 17.1712 13.5 18C13.5 18.8288 12.8287 19.5 12 19.5ZM14.4353 11.9108C14.889 11.5453 15.3576 11.1678 15.6945 10.7663C16.266 10.086 16.5 9.39825 16.5 8.5365C16.5 7.5105 16.1513 6.7065 15.453 6.12375C14.7548 5.541 13.8112 5.25 12.6217 5.25C11.214 5.25 9.894 5.59275 8.66175 6.279L9.42675 7.881C10.893 7.15725 11.7203 7.04325 12.4672 7.04325C13.6005 7.04325 14.4427 7.49925 14.4427 8.62725C14.4427 9.6405 13.935 10.1348 12.7312 11.085C12.1245 11.5583 11.6993 12.0165 11.457 12.4598C11.0854 13.1379 11.0892 13.8787 11.092 14.4228C11.0923 14.4684 11.0925 14.5126 11.0925 14.5553H12.8775V14.5442C12.8775 14.0667 12.8775 13.5604 13.164 13.1243C13.4265 12.7235 13.9213 12.3249 14.4353 11.9108Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.4e534daa05cfe83d75eb579591e5a887.svg";
export { ForwardRef as ReactComponent };